import { z } from "zod";


const ACCEPTED_IMAGE_TYPES = ["jpeg", "jpg", "png", "webp"];
const ImgSchema = z.object({
  fileName: z.string(),
  name: z.string(),
  fileSize: z.number(),
  size: z.number(),
  key: z.string(),
});
export const IMG_MAX_LIMIT = 1;

export const projectSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(1, { message: "Le titre est obligatoire" }),
  description: z
    .string({ required_error: "La description est obligatoire" })
    .min(1, { message: "La description  est obligatoire" }),
  date_debut: z.date({
    required_error: "La date de début est obligatoire",
  }),
  date_fin: z.date({
    required_error: "La date de fin est obligatoire",
  }),

  image: z
      .array(ImgSchema, { required_error: "L'image est obligatoire" })
      .max(IMG_MAX_LIMIT, {
        message: "Vous ne pouvez ajouter qu'une seule image.",
      })
      .min(1, { message: "L'image est obligatoire" })
      .refine(
        (images) => {
          const invalidImages = images.filter((img) => {
            const fileExtension = img.fileName.split(".").pop()?.toLowerCase();
            return fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension);
          });
          return invalidImages.length === 0;
        },
        {
          message: "Le type de fichier de l'image n'est pas pris en charge.",
        }
      ),
});

export type ProjectFormValues = z.infer<typeof projectSchema>;

export const updateProjectSchema = z
  .object({
    title: z.string().min(1, { message: "Le titre est obligatoire" }),
    description: z
      .string()
      .min(1, { message: "La description  est obligatoire" }),
    date_debut: z.date({
      required_error: "La date est obligatoire",
    }),
    date_fin: z.date({
      required_error: "La date est obligatoire",
    }),
    image: z
          .array(ImgSchema)
          .max(IMG_MAX_LIMIT, {
            message: "Vous ne pouvez ajouter qu'une seule image.",
          })
          .min(1, { message: "Au moins une image doit être ajoutée." })
          .refine(
            (images) => {
              // Only validate if images are present
              if (images && images.length > 0) {
                const invalidImages = images.filter((img) => {
                  const fileExtension = img.fileName
                    .split(".")
                    .pop()
                    ?.toLowerCase();
                  return (
                    fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension)
                  );
                });
                return invalidImages.length === 0;
              }
              // If images is undefined or empty, don't apply any validation.
              return true;
            },
            {
              message: "Le type de fichier de l'image n'est pas pris en charge.",
            }
          )
          .optional(),
  })
  .partial();

export type UpdateProjectFormValues = z.infer<typeof updateProjectSchema>;
